module.exports = __webpack_public_path__ + "img/guideFour.78f5143a.png";